import React from 'react'
// import Navtop from '../Topnavbar/Navtop'
// import Productsrange from './Productsrange'
import Footer from '../Footer/Footer'
import Gallary from '../Gallary'
import Popicon from '../Components/Popicon'
import Header from '../Header/Header'

export default function Onproducts() {
  return (
    <div>
    <Header />
    <Popicon />
    <div className="space-for-top" style={{marginTop:'10rem'}}>
              <Gallary />

    </div>
    
    <Footer />
      
    </div>
  )
}
